/***
 * Created on 2023/8/21
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import TrustCurrentDevice from "./trust_current_device";
import {useTranslation} from "react-i18next";
import TrustDeviceList from "./trust_device_list";

function ManageTrustedDevice({data}) {
    const { t } = useTranslation();

    return (
        <>
            {/* trust current device */}
            {/*<TrustCurrentDevice />*/}
            <section className="two-step--trusted-devices-list">
                <header>{t('@Trusted Devices and Computers@')}</header>
                {/* Trust device list */}
                <TrustDeviceList data={data} />
            </section>
        </>
    );
}

export default ManageTrustedDevice;